/**
 * Holds various device state, such as media size.
 */
import { MEDIA_QUERY_DEFAULTS, BREAKPOINT_BY_SCREEN_TYPE, SCREEN_TYPES } from 'constants/media-queries';

const SET_MEDIA_STATE = 'classpass/device/SET_MEDIA_STATE';
export const SET_IS_CLIENT = 'classpass/device/SET_IS_CLIENT';

export const setMediaState = mediaState => ({ type: SET_MEDIA_STATE, data: { key: 'media', val: mediaState } });
export const setIsClient = isClient => ({ type: SET_IS_CLIENT, data: { key: 'isClient', val: isClient } });

export const selectMediaState = state => state.device.media;
export const selectIsMobile = state => !state.device.media.md;
export const selectIsClient = state => state.device.isClient;

export const matchesScreenType = (screenType, state) => {
  const mediaState = selectMediaState(state) || {};
  return !!mediaState[BREAKPOINT_BY_SCREEN_TYPE[screenType]];
};

export const detectScreenType = state => {
  const matchesTablet = matchesScreenType(SCREEN_TYPES.tablet, state);
  const matchesDesktop = matchesScreenType(SCREEN_TYPES.desktop, state);
  return (matchesDesktop && 'desktop') || (matchesTablet && 'tablet') || 'phone';
};

const getInitialState = () => ({
  media: MEDIA_QUERY_DEFAULTS,
  isClient: false,
});

export default function reducer(state = getInitialState(), action = {}) {
  switch (action.type) {
    case SET_MEDIA_STATE:
    case SET_IS_CLIENT:
      return {
        ...state,
        [action.data.key]: action.data.val,
      };
    default:
      return state;
  }
}
